import api from '@/services/api/config';

const path = 'v1/werkzeug/historie/typ';

export default {
  get: () => api.get(path),
};
